module.exports = __webpack_public_path__ + "static/img/009.849ef7a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/datav-gejiachecun/009.png
// module id = u6zP
// module chunks = 1